import { useEffect } from "react"
import { MenuMenu, MenuItem, Menu, Segment, Icon } from 'semantic-ui-react'
import React from 'react'
import { NavLink, useLocation, useHistory } from 'react-router-dom'

export const MENU_ITEMS = {
    agents: 'agent',
    botAgents: 'bot agents'
}
const AgenTabs = ({ render }) => {
	const location = useLocation()
	const history = useHistory()
	const query = new URLSearchParams(location.search)
	const activeItem = query.get('tab') || MENU_ITEMS.agents

	const handleItemClick = (name) => () => {
		query.set('tab', name)
		history.push({ search: query.toString() })
	}

	useEffect(() => {
		if (!query.has('tab')) {
			query.set('tab', MENU_ITEMS.agents)
			history.replace({ search: query.toString() })
		}
	}, [location, history])

	return (
			<>
			<Menu pointing>
			<MenuItem
				name='Agents'
				active={activeItem === MENU_ITEMS.agents}
				onClick={handleItemClick(MENU_ITEMS.agents)}
			/>
			<MenuItem
				name='Bot Agents'
				active={activeItem === MENU_ITEMS.botAgents}
				onClick={handleItemClick(MENU_ITEMS.botAgents)}
			/>
			<MenuMenu position='right'>
					<MenuItem>
						<div className='content-header__actions'>
							<NavLink to='/admin/agents/create' className='button primary'>
								<Icon name="user plus"/>
								New Agent
							</NavLink>
						</div>
					</MenuItem>
			</MenuMenu>
			</Menu>
			<Segment>
					{render?.(activeItem)}
			</Segment>
		</>
	)
}

export default AgenTabs
